const nl = {
  search: 'zoeken'
}
const fr = {
  search: 'recherche'
}
export const dictionary = lang => (lang === 'fr' ? fr : nl)
